module.exports = __webpack_public_path__ + "img/3_137.7abd9300.png";